import React, { Component } from 'react';
import { connect } from 'react-redux';
import Spinner from '../Spinner'
import {isEmpty} from 'lodash'
import {getDashboardObject,getKontonFlagsById} from 'actions'
import Aktiviteter from '../DashboardComponents/Aktiviteter'
import Bokning from './Bokning'
import Dialer from './Dialer'
import Order from './Order'
import Prognos from '../DashboardComponents/Prognos'
import Prospekt from './Prospekt'
import Salj from './Sälj'
import BarnKonton from './BarnKonton'
import './Styless.css';
import { compose } from 'redux'
import {withStyles} from '@material-ui/core'
import BgImage from '../DashboardComponentsV2/Images/notyfile_dashboard_bg.svg'
import CreateWebsocket from '../CreateWebsokect' 


const styles = theme => ({
  //{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
  bg: {
    // backgroundImage: 'url('+BgImage+')',
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1920" height="1080" viewBox="0 0 1920 1080"><defs><style> .cls-1 { fill: %23fff; } .cls-2 { clip-path: url(%23clip-path); } .cls-3 { fill: url(%23radial-gradient); } .cls-4 { fill: url(%23radial-gradient-2); } </style><clipPath id="clip-path"><rect id="Rectangle_60" data-name="Rectangle 60" class="cls-1" width="1920" height="1080" transform="translate(15307 3416)"/></clipPath><radialGradient id="radial-gradient" cx="0.5" cy="0.5" r="0.498" gradientTransform="translate(0 -0.007) scale(1 1.015)" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="%23584c9c" stop-opacity="0.839"/><stop offset="0.293" stop-color="%235e52a0" stop-opacity="0.529"/><stop offset="0.536" stop-color="%23685da6" stop-opacity="0.22"/><stop offset="1" stop-color="%23fff" stop-opacity="0"/></radialGradient><radialGradient id="radial-gradient-2" cx="0.5" cy="0.5" r="0.498" gradientTransform="translate(0 -0.007) scale(1 1.015)" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="%233fbabd" stop-opacity="0.859"/><stop offset="0.293" stop-color="%233fbabd" stop-opacity="0.349"/><stop offset="0.586" stop-color="%233fbabd" stop-opacity="0.11"/><stop offset="1" stop-color="%23fff" stop-opacity="0"/></radialGradient></defs><g id="notyfile_dashboard_bg" class="cls-2" transform="translate(-15307 -3416)"><rect id="Rectangle_59" data-name="Rectangle 59" width="1920" height="1080" transform="translate(15307 3416)"/><circle id="Ellipse_1" data-name="Ellipse 1" class="cls-3" cx="927.577" cy="927.577" r="927.577" transform="matrix(0.966, -0.259, 0.259, 0.966, 14159, 2825.149)"/><circle id="Ellipse_2" data-name="Ellipse 2" class="cls-4" cx="1026" cy="1026" r="1026" transform="matrix(0.966, -0.259, 0.259, 0.966, 15970.412, 3714.784)"/><circle id="Ellipse_3" data-name="Ellipse 3" class="cls-4" cx="477.5" cy="477.5" r="477.5" transform="matrix(0.966, -0.259, 0.259, 0.966, 14722.185, 4203.172)"/><circle id="Ellipse_4" data-name="Ellipse 4" class="cls-3" cx="971.577" cy="971.577" r="971.577" transform="matrix(0.966, -0.259, 0.259, 0.966, 15077.066, 3930.081)"/><circle id="Ellipse_5" data-name="Ellipse 5" class="cls-3" cx="408.929" cy="408.929" r="408.929" transform="matrix(0.966, -0.259, 0.259, 0.966, 16726.166, 3126.843)"/><circle id="Ellipse_6" data-name="Ellipse 6" class="cls-4" cx="1114.5" cy="1114.5" r="1114.5" transform="matrix(0.966, -0.259, 0.259, 0.966, 14883.986, 2613.731)"/></g></svg>')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundColor: '#3a375c',
    postition: 'fixed',
    width: '100vw',
    height: '100vh'
  },
});


function mapStateToProps({accountsData}) {
    const {DashboardObjekt,Flags}=accountsData
    return {
        DashboardObjekt,Flags
    };
}
//dispatch(getKontonFlagsById(DashboardTVDeviceConnection.Afid))
function mapDispatchToProps(dispatch) {
    return {
        getDashboardObject:(Token) => dispatch(getDashboardObject(Token)),
        getKontonFlagsById:(Afid) => dispatch(getKontonFlagsById(Afid)),
    };
}

class DashboardTV extends Component {
    state={
        Objekt:{}
    }
    componentDidMount=()=>{
        let {Token}  = this.props.match.params;
        this.props.getDashboardObject(Token)
    }
    componentDidUpdate=()=>{
        if(this.state.Objekt !== this.props.DashboardObjekt){
          /*  try{
                document.getElementsByClassName("ld-chat-bot ld-chat-launcher")[0].style.display = "none"
                }
                catch(error){
                    console.log(error)
                }
                */
        //    document.getElementsByClassName("ld-chat-bot ld-chat-launcher")[0].style.display = "none"
            this.props.getKontonFlagsById(this.state.Objekt.Afid)
            this.setState({
                Objekt:this.props.DashboardObjekt
            })
        }
    }
    renderSwitch = () => {
        const Label= this.state.Objekt.Func; 
        switch(Label){
            case "Översikt":
                return <Prospekt Afid={this.state.Objekt.Afid}  Flags={this.props.Flags}/>
            case "Sälj TV":
                return <Salj Afid={this.state.Objekt.Afid}  Flags={this.props.Flags}/>
            case "Boka TV":
                return <Bokning Afid={this.state.Objekt.Afid}  Flags={this.props.Flags}/>
            case "Order":
                return <Order Afid={this.state.Objekt.Afid}   Flags={this.props.Flags}/>
            case "Aktiviteter":
                return <Aktiviteter Afid={this.state.Objekt.Afid}  Flags={this.props.Flags}/>
            case "Dialer":
                return <Dialer Afid={this.state.Objekt.Afid}  Flags={this.props.Flags}/>
            case "Prognos":
                return <Prognos Afid={this.state.Objekt.Afid}  Flags={this.props.Flags}/>
            case "Konton":
                return <BarnKonton Afid={this.state.Objekt.Afid}  Flags={this.props.Flags}/>
          
        }
    }

    render() {
      
        return (
            <>
            {
                isEmpty(this.state.Objekt)?
                <Spinner/>
                :
                <div className={"d-flex justify-content-center align-items-center w-100 " + this.props.classes.bg}>
                     {this.renderSwitch(this.state.Objekt)}
                     <CreateWebsocket Afid={this.state.Objekt.Afid} userid={`D-${this.state.Objekt.Afid}`}/>
                </div>
            }     
            </>
        );
    }
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles)
)(DashboardTV);